import clsx from "clsx";
import FormInput from "./FormInput";
import Filter from "./Filter";
import FormTextarea from "./FormTextarea";
import { FormField } from "../data/models";
import React, { ReactNode } from "react";

const options = ["209", "210"];

export interface FormSectionProps {
  title: string;
  fields: FormField[];
  columns?: 1 | 2;
  data?: Record<string, any>;
  name?: string;
  placeholder?: string;
  onChange?: (values: Record<string, any>) => void;
  setErrors: React.Dispatch<React.SetStateAction<string[]>>;
  errors: string[];
  children?: React.ReactNode;
  inputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>;

}

export function FormSection(props: FormSectionProps) {
  const {
    title,
    fields,
    columns = 1,
    data = {},
    onChange,
    setErrors,
    errors,
    children,
    inputRefs,
  } = props;

  const handleInputChange = (name: string, value: string | string[]) => {
    const updatedData = { ...data, [name]: value }; // Može prihvatiti string ili string[]
    if (value) {
      setErrors((prevErrors) => prevErrors.filter((error) => error !== name));
    }
    if (onChange) {
      onChange(updatedData);
    }
  };

  const layout = {
    1: "",
    2: "sm:grid-cols-2",
  };

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-medium text-gray-extra-dark">{title}</h3>
      <div
        className={clsx("grid grid-cols-1 gap-3", layout && layout[columns])}
      >
        {fields.map((field, index) => (
          <React.Fragment key={index}>
            {field.type !== "dropdown" && field.type !== "textarea" ? (
              <FormInput
                key={index}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                type={field.type}
                value={data[field.name] || ""}
                onChange={(e) => handleInputChange(field.name, e.target.value)}
                errors={errors}
                readOnly={field.readOnly}
                inputRefs={inputRefs}
              />
            ) : field.type === "dropdown" ? (
              <div key={index} className="flex flex-col gap-2">
                <label
                  htmlFor={field.name}
                  className="text-base opacity-80 text-gray-extra-dark"
                >
                  {field.name}
                  {field.required && (
                    <span className="pl-1 text-sm text-warning-red">*</span>
                  )}
                </label>
                <Filter
                  name={field.placeholder}
                  data={options}
                  selected={data[field.name] || []}
                  onChange={(values) => handleInputChange(field.name, values)}
                  multiple={false}
                  //errors={errors}
                ></Filter>
              </div>
            ) : field.type === "textarea" ? (
              <FormTextarea
                key={index}
                name={field.name}
                placeholder={field.placeholder}
                required={field.required}
                value={data[field.name] || ""}
                onChange={(e) => handleInputChange(field.name, e.target.value)}
                errors={errors}
              />
            ) : (
              <></>
            )}
          </React.Fragment>
        ))}
      </div>
      {children}
    </div>
  );
}

export default FormSection;
